
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { toast } from 'react-hot-toast'
import { clearToken } from '../reducers/authSlice'

const getBaseQueryWithReauth = (
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {

  const errorMessages = [
    "Invalid credentials",
    "Missing authentication"
  ]

  return async function (args, api, extraOptions) {
    let result = await baseQuery(args, api, extraOptions);

    // Only log and handle errors if there's actually an error
    if (result.error) {
      // @ts-ignore
      const errorMessage = result?.error?.data?.message;

      // Only log error message if it exists (avoid "undefined" spam)
      if (errorMessage) {
        console.log("Error message", errorMessage);
      }

      const isProfileRequest =
        (typeof args === "string" && args.includes("/user")) ||
        (typeof args === "object" &&
          args &&
          "url" in args &&
          String((args as FetchArgs).url).includes("/user"));

      // Profile bootstrap is handled in App.tsx (clear token + sign out + user-facing error).
      // Auto-clearing here caused loops with redux-persist and masked API Gateway / CORS failures.
      if (
        result.error.status === 401 &&
        !isProfileRequest &&
        (!errorMessages.includes(errorMessage) ||
          errorMessage === "Missing authentication")
      ) {
        toast("Your session has expired and you have been disconnected", { icon: '🔌', duration: 5000 });
        api.dispatch(clearToken());
      }
    }
    return result
  }
}

export default getBaseQueryWithReauth
